import abbreviations from './abbreviations.json';

// Lower-cased lookup built once: "tee" -> ["transesophageal echocardiography", ...]
// Keys that differ only by case (VT and Vt, MG and Mg) merge, so a search finds both meanings.
const byAbbreviation = {};
Object.entries(abbreviations).forEach(([abbr, fulls]) => {
  const key = abbr.toLowerCase();
  const list = byAbbreviation[key] || (byAbbreviation[key] = []);
  fulls.forEach((f) => { const lf = f.toLowerCase(); if (!list.includes(lf)) list.push(lf); });
});

/**
 * A search query plus the terms it stands for, all lower-cased:
 *  - an abbreviation adds its expansions ("tee" -> transesophageal echo…)
 *  - a word of 4+ letters inside an expansion adds the abbreviation ("aneurysm" -> aaa, taaa…)
 * Match content against any of the returned terms.
 */
export const expandQuery = (query) => {
  const q = (query || '').trim().toLowerCase();
  if (!q) return [];
  const terms = new Set([q]);
  for (const [abbr, fulls] of Object.entries(byAbbreviation)) {
    if (abbr === q) fulls.forEach((f) => terms.add(f));
    else if (q.length >= 4 && fulls.some((f) => f.includes(q))) terms.add(abbr);
  }
  return [...terms];
};

// Content often uses a clipped form of an expansion ("transesophageal echo" for
// "transesophageal echocardiography"), so multi-word terms match when each word
// is a prefix of a word in the text, or vice versa.
const wordMatches = (word, textWords) =>
  textWords.some((tw) => (tw.startsWith(word) && word.length >= 3) || (word.startsWith(tw) && tw.length >= 4));

export const textMatchesAny = (text, terms) => {
  const t = (text || '').toLowerCase();
  if (terms.some((term) => t.includes(term))) return true;
  const textWords = t.split(/[^a-z0-9]+/).filter(Boolean);
  return terms.some((term) => {
    const words = term.split(/\s+/).filter((w) => w.length >= 3);
    return words.length > 1 && words.every((w) => wordMatches(w, textWords));
  });
};
